import { useEffect, useState } from "react";

import AppEventTarget, {
  appEventTypes,
} from "@src/common/events/AppEventTarget";
import ImpersonateEvent from "@src/common/events/ImpersonateEvent";
import {
  getImpersonateUser,
  ImpersonatedUserData,
} from "@src/common/helpers/impersonatedUser";

const useImpersonateEventHandler = () => {
  const [user, setUser] = useState<ImpersonatedUserData | null>(
    getImpersonateUser(),
  );

  useEffect(() => {
    const handler = ({ detail: { impersonatedUser } }: ImpersonateEvent) => {
      setUser(impersonatedUser);
    };

    AppEventTarget.addEventListener(appEventTypes.IMPERSONATE, {
      handleEvent: handler,
    });
    return () => {
      AppEventTarget.removeEventListener(appEventTypes.IMPERSONATE, {
        handleEvent: handler,
      });
    };
  }, []);

  return [user];
};

export default useImpersonateEventHandler;
